var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.75C18 7.1875 17.6562 7.5 17.25 7.5H15.125L10.5312 18.5H13.25C13.6562 18.5 14 18.8438 14 19.25C14 19.6875 13.6562 20 13.25 20H6.75C6.3125 20 6 19.6875 6 19.25C6 18.8438 6.3125 18.5 6.75 18.5H8.9375L13.5312 7.5H10.75C10.3125 7.5 10 7.1875 10 6.75C10 6.34375 10.3125 6 10.75 6H17.25C17.6562 6 18 6.34375 18 6.75Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/Italic.1ac64bffc2ac7ddd28ced5378b31ef81.svg";
export { ForwardRef as ReactComponent };